import * as branch from 'api/branch';
import { WEB_INSIGHTTIMER_INTERNAL_LINK } from 'Config/constants';
import { usePageViewTracker } from 'context/PageViewTracker';
import { GA_CLICK_EVENT_NAMES } from 'lib/firebase/ga_events';
import { isIOS, isMobile } from 'react-device-detect';
import { useAnalytics } from './useAnalytics';

interface DownloadAppCallbackConfig {
  queryString?: string; // used to send branch link along with web link in desktop.
}

interface Params {
  isClickTrackable?: boolean;
}

const useDownloadAppHandler = (params?: Params) => {
  const { isClickTrackable = true } = params || {};
  const { pageType, deepLink } = usePageViewTracker();
  const { trackGAClickEvent } = useAnalytics();

  const downloadAppCallback = (e: any, config?: DownloadAppCallbackConfig) => {
    if (isClickTrackable)
      trackGAClickEvent({
        click_event_name: isMobile
          ? isIOS
            ? GA_CLICK_EVENT_NAMES.DOWNLOAD_APP_IOS_CLICKED
            : GA_CLICK_EVENT_NAMES.DOWNLOAD_APP_ANDROID_CLICKED
          : GA_CLICK_EVENT_NAMES.DOWNLOAD_APP_CLICKED
      });
    let query = branch.analyticsQuery(pageType);
    if (deepLink) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      query += `&$deeplink_v2=${deepLink}&$deeplink=${deepLink}`;
    }
    if (!isMobile) {
      const { queryString } = config ?? {};
      let url = `${WEB_INSIGHTTIMER_INTERNAL_LINK}/download-app`;

      if (queryString?.trim()) {
        url += `?${queryString}`;
      }

      window.open(url, '_blank');
    }

    window.open(
      `https://insig.ht/appDownload${query ? `?${query}` : ''}`,
      '_blank'
    );
  };

  return downloadAppCallback;
};

export default useDownloadAppHandler;
